/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "ERC721IncorrectOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ERC721InsufficientApproval",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC721InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "ERC721InvalidOperator",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "ERC721InvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC721InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC721InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ERC721NonexistentToken",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                indexed: false,
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "managementContract",
                type: "address",
            },
        ],
        name: "ReceiptInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MANAGEMENT_SMART_CONTRACT_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
            {
                internalType: "address",
                name: "managementContract",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_nextTokenId",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "supported",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class Receipt__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
Receipt__factory.bytecode = _bytecode;
Receipt__factory.abi = _abi;
//# sourceMappingURL=Receipt__factory.js.map